import {UserReceiverService} from '../../libs/ui/src/index';

import {client} from '../apiService';

const _UserReceiverService = new UserReceiverService({client});
export {_UserReceiverService as UserReceiverService};
